import type { FlowChainSlot, FlowNodeInput } from "@/types/flow"

export type FlowSlotMove =
  | { slot_index: number; swap_with_slot: number }
  | { slot_index: number; source_node_id: number }

export type FlowSlotDrop = {
  patch: FlowSlotMove
  /** edge id → слот, который панель показывает, пока сервер не подтвердил бросок. */
  override: Map<number, number>
}

export function flowSlotDrop(
  slots: readonly FlowChainSlot[],
  inputs: readonly FlowNodeInput[],
  from: number,
  to: number,
): FlowSlotDrop | null {
  if (from === to) return null
  const source = slots.find((slot) => slot.position === from)
  const target = slots.find((slot) => slot.position === to)
  if (!source || !target || source.media !== target.media) return null

  const moving = inputs.find((input) => input.slot_index === from)
  if (!moving) return null

  const occupant = inputs.find((input) => input.slot_index === to)
  const override = new Map<number, number>()
  if (occupant) {
    override.set(moving.id, to)
    override.set(occupant.id, from)
    return { patch: { slot_index: from, swap_with_slot: to }, override }
  }

  override.set(moving.id, to)
  return { patch: { slot_index: to, source_node_id: moving.source_node_id }, override }
}

export function withSlotOverride(
  inputs: readonly FlowNodeInput[],
  override: ReadonlyMap<number, number> | null,
): readonly FlowNodeInput[] {
  if (!override || override.size === 0) return inputs

  let changed = false
  const next = inputs.map((input) => {
    const slot = override.get(input.id)
    if (slot == null || slot === input.slot_index) return input
    changed = true
    return { ...input, slot_index: slot }
  })
  return changed ? next : inputs
}
